import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconThermostat: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconThermostat"><Path d="M15.5 3.5H19.5M15.5 7.5H19.5M15.5 11.5H19.5M7.5 2.5H10.5V12.7561C12.2478 13.3738 13.5 15.0407 13.5 17C13.5 19.4853 11.4853 21.5 9 21.5C6.51472 21.5 4.5 19.4853 4.5 17C4.5 15.0407 5.75221 13.3738 7.5 12.7561V2.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconThermostat;
